import CloseIcon from "../../assets/svg/CloseIcon";
import {
  useCsPreferencesUpdateNotice,
  useDismissCsPreferencesNotice,
} from "../../services/utils/custom hooks/Communication/useCommunicationPreferences";

function CsPreferencesUpdatedBanner(): JSX.Element | null {
  const { data: notice } = useCsPreferencesUpdateNotice();
  const dismissMutation = useDismissCsPreferencesNotice();

  if (!notice?.visible) return null;

  return (
    <div className="mx-5 mt-4 py-3 px-4 flex items-start justify-between bg-teal-50 border border-teal-500 rounded-md">
      <div className="text-teal-700 text-sm pr-4">
        <p className="font-semibold">Preferences updated by Clinical Services</p>
        <p className="mt-1">
          Your communication preferences were recently updated by a Clinical
          Services coordinator
          {notice.updatedAt
            ? ` on ${new Date(notice.updatedAt).toLocaleString()}`
            : ""}
          . Review your settings to confirm they match your preferences.
        </p>
      </div>
      <button
        type="button"
        aria-label="Dismiss"
        onClick={() => dismissMutation.mutate()}
        className="shrink-0 p-1"
      >
        <CloseIcon />
      </button>
    </div>
  );
}

export default CsPreferencesUpdatedBanner;
